export enum ActivityStreamType {
  Primary = 1,
  Parallel,
}
